module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/Informacje-o-produkcji-green-b833bdde.svg";